import CONST_STORAGE from 'constants/storage';

export const setStorageTestOnly = (item: string) =>
  localStorage.setItem(CONST_STORAGE.SYSTEM_CONFIG.TEST_ONLY, item);

export const getTestOnly = () =>
  localStorage.getItem(CONST_STORAGE.SYSTEM_CONFIG.TEST_ONLY) || 'true';
